import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HelpDocumentionComponent } from './help-documention/help-documention.component';


 const routes: Routes = [
    {
      path: '',
      pathMatch: 'full',
      component:HelpDocumentionComponent
    }
  ];
 @NgModule({
   imports: [RouterModule.forChild(routes)],
 exports: [RouterModule]
 })
 export class HelpDocRoutingModule { }
